/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BulkOperationsRequestBody,
    BulkOperationsRequestBodyFromJSON,
    BulkOperationsRequestBodyToJSON,
    Group,
    GroupFromJSON,
    GroupToJSON,
    GroupMap,
    GroupMapFromJSON,
    GroupMapToJSON,
    GroupRequestBody,
    GroupRequestBodyFromJSON,
    GroupRequestBodyToJSON,
    Groups,
    GroupsFromJSON,
    GroupsToJSON,
    PatchRequestBody,
    PatchRequestBodyFromJSON,
    PatchRequestBodyToJSON,
    ProblemDetail,
    ProblemDetailFromJSON,
    ProblemDetailToJSON,
} from '../models';

export interface ArchiveGroupsRequest {
    project_id: number;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

export interface CreateGroupRequest {
    project_id: number;
    group_request_body: GroupRequestBody;
}

export interface DeleteGroupRequest {
    project_id: number;
    group_id: number;
}

export interface FetchGroupRequest {
    project_id: number;
    group_id: number;
}

export interface ListGroupsRequest {
    project_id: number;
    per_page?: number;
    page_token?: string;
    page_window?: number;
    sort?: Array<ListGroupsSortEnum>;
    archived?: boolean;
    enabled?: boolean;
    environment?: Array<string>;
    query?: string;
    include?: Array<string>;
}

export interface UnarchiveGroupsRequest {
    project_id: number;
    bulk_operations_request_body: BulkOperationsRequestBody;
}

export interface UpdateGroupsRequest {
    project_id: number;
    patch_request_body: Array<PatchRequestBody>;
}

/**
 * no description
 */
export class GroupsApi extends runtime.BaseAPI {

    /**
     * Archive one or more exclusion groups in a project.  This operation corresponds to the `archive_url` in a Groups response. 
     * Archive Exclusion Groups
     */
    async archiveGroupsRaw(requestParameters: ArchiveGroupsRequest): Promise<runtime.ApiResponse<GroupMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling archiveGroups.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling archiveGroups.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/groups/archived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupMapFromJSON(jsonValue));
    }

    /**
     * Archive one or more exclusion groups in a project.  This operation corresponds to the `archive_url` in a Groups response. 
     * Archive Exclusion Groups
     */
    async archiveGroups(requestParameters: ArchiveGroupsRequest): Promise<GroupMap> {
        const response = await this.archiveGroupsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Creates a new exclusion group in a project.  This operation corresponds to the `create_url` in a Groups response.  Required properties must be present in the request body.  Note that key for each object in \"rules\" (if provided), must be a stringified rule ID. 
     * Create an Exclusion Group
     */
    async createGroupRaw(requestParameters: CreateGroupRequest): Promise<runtime.ApiResponse<Group>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling createGroup.');
        }

        if (requestParameters.group_request_body === null || requestParameters.group_request_body === undefined) {
            throw new runtime.RequiredError('group_request_body','Required parameter requestParameters.group_request_body was null or undefined when calling createGroup.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/groups`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GroupRequestBodyToJSON(requestParameters.group_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupFromJSON(jsonValue));
    }

    /**
     * Creates a new exclusion group in a project.  This operation corresponds to the `create_url` in a Groups response.  Required properties must be present in the request body.  Note that key for each object in \"rules\" (if provided), must be a stringified rule ID. 
     * Create an Exclusion Group
     */
    async createGroup(requestParameters: CreateGroupRequest): Promise<Group> {
        const response = await this.createGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     * Permanently delete an exclusion group by id.  There will be no way to access this data after deleting. If you want to stop seeing a Group without deleting it permanently, archive instead. 
     * Delete an Exclusion Group
     */
    async deleteGroupRaw(requestParameters: DeleteGroupRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling deleteGroup.');
        }

        if (requestParameters.group_id === null || requestParameters.group_id === undefined) {
            throw new runtime.RequiredError('group_id','Required parameter requestParameters.group_id was null or undefined when calling deleteGroup.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/groups/{group_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters.group_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Permanently delete an exclusion group by id.  There will be no way to access this data after deleting. If you want to stop seeing a Group without deleting it permanently, archive instead. 
     * Delete an Exclusion Group
     */
    async deleteGroup(requestParameters: DeleteGroupRequest): Promise<void> {
        await this.deleteGroupRaw(requestParameters);
    }

    /**
     * Fetch a single exclusion group by its id.  This operation corresponds to the `fetch_group_url` in a Groups response. 
     * Fetch a Single Exclusion Group
     */
    async fetchGroupRaw(requestParameters: FetchGroupRequest): Promise<runtime.ApiResponse<Group>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling fetchGroup.');
        }

        if (requestParameters.group_id === null || requestParameters.group_id === undefined) {
            throw new runtime.RequiredError('group_id','Required parameter requestParameters.group_id was null or undefined when calling fetchGroup.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/groups/{group_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"group_id"}}`, encodeURIComponent(String(requestParameters.group_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupFromJSON(jsonValue));
    }

    /**
     * Fetch a single exclusion group by its id.  This operation corresponds to the `fetch_group_url` in a Groups response. 
     * Fetch a Single Exclusion Group
     */
    async fetchGroup(requestParameters: FetchGroupRequest): Promise<Group> {
        const response = await this.fetchGroupRaw(requestParameters);
        return await response.value();
    }

    /**
     * Get a list of exclusion groups within a project  You can use query parameters to filter/sort the response. 
     * List Exclusion Groups
     */
    async listGroupsRaw(requestParameters: ListGroupsRequest): Promise<runtime.ApiResponse<Groups>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling listGroups.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.per_page !== undefined) {
            queryParameters['per_page'] = requestParameters.per_page;
        }

        if (requestParameters.page_token !== undefined) {
            queryParameters['page_token'] = requestParameters.page_token;
        }

        if (requestParameters.page_window !== undefined) {
            queryParameters['page_window'] = requestParameters.page_window;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.archived !== undefined) {
            queryParameters['archived'] = requestParameters.archived;
        }

        if (requestParameters.enabled !== undefined) {
            queryParameters['enabled'] = requestParameters.enabled;
        }

        if (requestParameters.environment) {
            queryParameters['environment'] = requestParameters.environment;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        if (requestParameters.include) {
            queryParameters['include'] = requestParameters.include.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/groups`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupsFromJSON(jsonValue));
    }

    /**
     * Get a list of exclusion groups within a project  You can use query parameters to filter/sort the response. 
     * List Exclusion Groups
     */
    async listGroups(requestParameters: ListGroupsRequest): Promise<Groups> {
        const response = await this.listGroupsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Unarchive one or more exclusion groups in a project.  This operation corresponds to the `unarchive_url` in a Groups response. 
     * Unarchive Exclusion Groups
     */
    async unarchiveGroupsRaw(requestParameters: UnarchiveGroupsRequest): Promise<runtime.ApiResponse<GroupMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling unarchiveGroups.');
        }

        if (requestParameters.bulk_operations_request_body === null || requestParameters.bulk_operations_request_body === undefined) {
            throw new runtime.RequiredError('bulk_operations_request_body','Required parameter requestParameters.bulk_operations_request_body was null or undefined when calling unarchiveGroups.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/groups/unarchived`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BulkOperationsRequestBodyToJSON(requestParameters.bulk_operations_request_body),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupMapFromJSON(jsonValue));
    }

    /**
     * Unarchive one or more exclusion groups in a project.  This operation corresponds to the `unarchive_url` in a Groups response. 
     * Unarchive Exclusion Groups
     */
    async unarchiveGroups(requestParameters: UnarchiveGroupsRequest): Promise<GroupMap> {
        const response = await this.unarchiveGroupsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update one or more Groups in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Exclusion Groups
     */
    async updateGroupsRaw(requestParameters: UpdateGroupsRequest): Promise<runtime.ApiResponse<GroupMap>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateGroups.');
        }

        if (requestParameters.patch_request_body === null || requestParameters.patch_request_body === undefined) {
            throw new runtime.RequiredError('patch_request_body','Required parameter requestParameters.patch_request_body was null or undefined when calling updateGroups.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/projects/{project_id}/groups`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patch_request_body.map(PatchRequestBodyToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupMapFromJSON(jsonValue));
    }

    /**
     * Update one or more Groups in a project using a json patch structure.  Properties that are readOnly that are present in the request body will be ignored as well as unknown properties. 
     * Update Exclusion Groups
     */
    async updateGroups(requestParameters: UpdateGroupsRequest): Promise<GroupMap> {
        const response = await this.updateGroupsRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListGroupsSortEnum {
    Nameasc = 'name:asc',
    Namedesc = 'name:desc',
    CreatedTimeasc = 'created_time:asc',
    CreatedTimedesc = 'created_time:desc',
    UpdatedTimeasc = 'updated_time:asc',
    UpdatedTimedesc = 'updated_time:desc'
}
